import ControlLabel from 'erxes-ui/lib/components/form/Label';

export default ControlLabel;
